/* This file is autogenerated, see readme.md for instructions */
import StarFillSvgIcon from '@bloomreach/banana-theme/icons/star-fill.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const StarFillIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <StarFillSvgIcon />
    </Icon>
  );
});

StarFillIcon.displayName = 'StarFillIcon';

export default StarFillIcon;
